/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.News
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const ActionResponseStatusEnum = {
    Ok: 'Ok',
    Error: 'Error',
    Bad: 'Bad',
    NoData: 'NoData'
} as const;

export type ActionResponseStatusEnum = typeof ActionResponseStatusEnum[keyof typeof ActionResponseStatusEnum];


/**
 * 
 * @export
 * @interface AttachmentInfo
 */
export interface AttachmentInfo {
    /**
     * 
     * @type {string}
     * @memberof AttachmentInfo
     */
    'uri'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttachmentInfo
     */
    'fileName'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Indexes = {
    Any: 'ANY',
    Xgymo: 'XGYMO',
    Xhold: 'XHOLD',
    Xsgrt: 'XSGRT',
    Xtast: 'XTAST',
    Xu030: 'XU030',
    Xu100: 'XU100',
    Xutum: 'XUTUM',
    Xtm25: 'XTM25',
    Xtmtu: 'XTMTU',
    X10Xb: 'X10XB',
    Xlbnk: 'XLBNK',
    Xk030: 'XK030'
} as const;

export type Indexes = typeof Indexes[keyof typeof Indexes];


/**
 * 
 * @export
 * @enum {string}
 */

export const NewsEntityType = {
    Hepsi: 'Hepsi',
    FinansalRaporlar: 'FinansalRaporlar',
    VergiBilancolari: 'VergiBilancolari',
    TemettuveSermayeArttirimi: 'TemettuveSermayeArttirimi',
    OzelDurumAciklamalari: 'OzelDurumAciklamalari',
    PayAlimSatimBildirimi: 'PayAlimSatimBildirimi',
    Diger: 'Diger'
} as const;

export type NewsEntityType = typeof NewsEntityType[keyof typeof NewsEntityType];


/**
 * 
 * @export
 * @interface NewsInfo
 */
export interface NewsInfo {
    /**
     * 
     * @type {string}
     * @memberof NewsInfo
     */
    'globalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsInfo
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsInfo
     */
    'type'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewsInfo
     */
    'stocks'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof NewsInfo
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NewsInfo
     */
    'detail'?: string | null;
    /**
     * 
     * @type {Array<AttachmentInfo>}
     * @memberof NewsInfo
     */
    'attachments'?: Array<AttachmentInfo> | null;
}
/**
 * 
 * @export
 * @interface NewsInfoIEnumerableActionResponse
 */
export interface NewsInfoIEnumerableActionResponse {
    /**
     * 
     * @type {Array<NewsInfo>}
     * @memberof NewsInfoIEnumerableActionResponse
     */
    'data'?: Array<NewsInfo> | null;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof NewsInfoIEnumerableActionResponse
     */
    'status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof NewsInfoIEnumerableActionResponse
     */
    'error'?: string | null;
}



/**
 * KapApi - axios parameter creator
 * @export
 */
export const KapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Indexes} constutientEntityId 
         * @param {Array<NewsEntityType>} newsTypes 
         * @param {string} beginOfDate 
         * @param {string} identityToken 
         * @param {Array<string>} [securityCodes] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKapNewsGet: async (constutientEntityId: Indexes, newsTypes: Array<NewsEntityType>, beginOfDate: string, identityToken: string, securityCodes?: Array<string>, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'constutientEntityId' is not null or undefined
            assertParamExists('apiKapNewsGet', 'constutientEntityId', constutientEntityId)
            // verify required parameter 'newsTypes' is not null or undefined
            assertParamExists('apiKapNewsGet', 'newsTypes', newsTypes)
            // verify required parameter 'beginOfDate' is not null or undefined
            assertParamExists('apiKapNewsGet', 'beginOfDate', beginOfDate)
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiKapNewsGet', 'identityToken', identityToken)
            const localVarPath = `/api/kap/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (constutientEntityId !== undefined) {
                localVarQueryParameter['ConstutientEntityId'] = constutientEntityId;
            }

            if (securityCodes) {
                localVarQueryParameter['SecurityCodes'] = securityCodes;
            }

            if (newsTypes) {
                localVarQueryParameter['NewsTypes'] = newsTypes;
            }

            if (beginOfDate !== undefined) {
                localVarQueryParameter['BeginOfDate'] = (beginOfDate as any instanceof Date) ?
                    (beginOfDate as any).toISOString() :
                    beginOfDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KapApi - functional programming interface
 * @export
 */
export const KapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KapApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Indexes} constutientEntityId 
         * @param {Array<NewsEntityType>} newsTypes 
         * @param {string} beginOfDate 
         * @param {string} identityToken 
         * @param {Array<string>} [securityCodes] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKapNewsGet(constutientEntityId: Indexes, newsTypes: Array<NewsEntityType>, beginOfDate: string, identityToken: string, securityCodes?: Array<string>, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsInfoIEnumerableActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKapNewsGet(constutientEntityId, newsTypes, beginOfDate, identityToken, securityCodes, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KapApi - factory interface
 * @export
 */
export const KapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KapApiFp(configuration)
    return {
        /**
         * 
         * @param {Indexes} constutientEntityId 
         * @param {Array<NewsEntityType>} newsTypes 
         * @param {string} beginOfDate 
         * @param {string} identityToken 
         * @param {Array<string>} [securityCodes] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKapNewsGet(constutientEntityId: Indexes, newsTypes: Array<NewsEntityType>, beginOfDate: string, identityToken: string, securityCodes?: Array<string>, limit?: number, offset?: number, options?: any): AxiosPromise<NewsInfoIEnumerableActionResponse> {
            return localVarFp.apiKapNewsGet(constutientEntityId, newsTypes, beginOfDate, identityToken, securityCodes, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KapApi - object-oriented interface
 * @export
 * @class KapApi
 * @extends {BaseAPI}
 */
export class KapApi extends BaseAPI {
    /**
     * 
     * @param {Indexes} constutientEntityId 
     * @param {Array<NewsEntityType>} newsTypes 
     * @param {string} beginOfDate 
     * @param {string} identityToken 
     * @param {Array<string>} [securityCodes] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KapApi
     */
    public apiKapNewsGet(constutientEntityId: Indexes, newsTypes: Array<NewsEntityType>, beginOfDate: string, identityToken: string, securityCodes?: Array<string>, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return KapApiFp(this.configuration).apiKapNewsGet(constutientEntityId, newsTypes, beginOfDate, identityToken, securityCodes, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



